import React, { FunctionComponent, ReactNode } from 'react';
import * as styles from './ListRenderer.style';

export interface ListRendererProps {
  ordered: boolean,
  children: ReactNode,
}

const ListRenderer: FunctionComponent<ListRendererProps> = ({
  ordered,
  children,
}) => (ordered ? (
  <ol
    css={styles.list}
    ordered={ordered}
  >
    {children}
  </ol>
) : (
  <ul
    css={styles.list}
    ordered={ordered}
  >
    {children}
  </ul>
));

export default ListRenderer;
